import * as React from "react"
import type { SVGProps } from "react"
export const MoreHorizontalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.23 13.5q-.618 0-1.059-.44a1.45 1.45 0 0 1-.44-1.06q0-.619.44-1.06.44-.44 1.06-.44.618 0 1.059.44.44.441.44 1.06t-.44 1.06q-.44.44-1.06.44m5.77 0q-.62 0-1.06-.44A1.44 1.44 0 0 1 10.5 12q0-.619.44-1.06.44-.44 1.06-.44.618 0 1.059.44.44.441.44 1.06t-.44 1.06q-.44.44-1.06.44Zm5.769 0q-.62 0-1.06-.44a1.45 1.45 0 0 1-.44-1.06q0-.619.44-1.06.44-.44 1.06-.44.618 0 1.06.44.44.441.44 1.06t-.44 1.06a1.45 1.45 0 0 1-1.06.44"
    ></path>
  </svg>
)
